import type {
  EcoLabelData,
  EcoLabelItem,
  EcoLabelItemMode,
  ValidatedEcoLabelItem,
} from '../../types';

export type EcoLabelItemValidationProps = {
  ecoLabelData: EcoLabelItem;
  mode?: EcoLabelItemMode;
};

type EcoLabelValidationData = EcoLabelItem & {
  mode?: EcoLabelItemMode;
};

export const isValidEcoLabelItem = ({
  iconUrl,
  license,
  text,
  mode = 'normal',
}: EcoLabelValidationData) => {
  if (mode === 'productStandard' && !iconUrl) {
    return false;
  }

  return Boolean(iconUrl || license || text);
};

const isValidatedEcoLabelItem = (
  item: EcoLabelItem | ValidatedEcoLabelItem,
): item is ValidatedEcoLabelItem => 'key' in item;

const isValidatedEcoLabelData = (data: EcoLabelData): data is ValidatedEcoLabelItem[] =>
  data.length > 0 && isValidatedEcoLabelItem(data[0]);

export const getValidatedEcoLabelData = (
  data: EcoLabelData | null | undefined,
  mode: EcoLabelItemMode = 'normal',
) => {
  if (!data || data.length === 0) {
    return [];
  }

  if (isValidatedEcoLabelData(data)) {
    return data;
  }

  const validatedData: ValidatedEcoLabelItem[] = [];

  data.forEach((item, idx) => {
    if (isValidEcoLabelItem({ ...item, mode })) {
      validatedData.push({ data: item, key: `${mode}-${idx}` });
    }
  });

  return validatedData;
};
